import PropTypes from 'prop-types';

export const ChargePolicy = PropTypes.shape({
  amount: PropTypes.number.isRequired,
  effectiveUntil: PropTypes.instanceOf(Date).isRequired
});

export const Fee = PropTypes.shape({
  chargePolicies: PropTypes.arrayOf(ChargePolicy)
});

export const Fees = PropTypes.object;

export const SpeakerWebsite = PropTypes.shape({
  isDisplay: PropTypes.bool.isRequired,
  relatedUrl: PropTypes.string.isRequired,
  relatedUrlName: PropTypes.string.isRequired
});

export const Speaker = PropTypes.shape({
  id: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  prefix: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  categoryId: PropTypes.string.isRequired,
  biography: PropTypes.string.isRequired,
  designation: PropTypes.string.isRequired,
  facebookUrl: PropTypes.string.isRequired,
  linkedInUrl: PropTypes.string.isRequired,
  twitterUrl: PropTypes.string.isRequired,
  profileImageUri: PropTypes.string,
  profileImageFileName: PropTypes.string,
  websites: PropTypes.object,
  order: PropTypes.number.isRequired
});

export const SpeakerDisplayOptions = PropTypes.shape({
  profileImage: PropTypes.bool,
  prefix: PropTypes.bool.isRequired,
  title: PropTypes.bool.isRequired,
  company: PropTypes.bool.isRequired
});

export const SpeakerCategory = PropTypes.shape({
  id: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  order: PropTypes.number.isRequired
});

export const Staff = PropTypes.shape({
  id: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  workAddress: PropTypes.object,
  profileImageUri: PropTypes.string,
  profileImageFileName: PropTypes.string
});

export const Product = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  fees: Fees,
  capacityId: PropTypes.string.isRequired
});

export const AdmissionItem = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  fees: Fees,
  capacityId: PropTypes.string.isRequired,
  applicableContactTypes: PropTypes.arrayOf(PropTypes.string),
  limitOptionalSessionsToSelect: PropTypes.bool.isRequired,
  availableOptionalSessions: PropTypes.arrayOf(PropTypes.string),
  associatedOptionalSessions: PropTypes.arrayOf(PropTypes.string),
  minimumNumberOfSessionsToSelect: PropTypes.number.isRequired,
  maximumNumberOfSessionsToSelect: PropTypes.number,
  isOpenForRegistration: PropTypes.bool.isRequired,
  autoCloseDate: PropTypes.string
});

export const AdmissionItemsById = PropTypes.object;

export const Session = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  fees: Fees,
  capacityId: PropTypes.string.isRequired,
  isIncludedSession: PropTypes.bool.isRequired,
  startTime: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
  locationName: PropTypes.string.isRequired,
  locationCode: PropTypes.string.isRequired,
  categoryId: PropTypes.string.isRequired,
  capacity: PropTypes.number.isRequired,
  registeredCount: PropTypes.number.isRequired,
  associatedRegistrationTypes: PropTypes.arrayOf(PropTypes.string),
  isOpenForRegistration: PropTypes.bool.isRequired,
  autoCloseDate: PropTypes.string,
  status: PropTypes.number.isRequired,
  sessionCustomFieldValues: PropTypes.object,
  speakers: PropTypes.arrayOf(Speaker),
  speakerIds: PropTypes.object
});

export const SessionGroup = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  fees: Fees,
  capacityId: PropTypes.string.isRequired,
  isIncludedSession: PropTypes.bool.isRequired,
  startTime: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
  locationName: PropTypes.string.isRequired,
  locationCode: PropTypes.string.isRequired,
  categoryId: PropTypes.string.isRequired,
  capacity: PropTypes.number.isRequired,
  registeredCount: PropTypes.number.isRequired,
  associatedRegistrationTypes: PropTypes.arrayOf(PropTypes.string),
  isOpenForRegistration: PropTypes.bool.isRequired,
  autoCloseDate: PropTypes.string,
  status: PropTypes.number.isRequired,
  sessionCustomFieldValues: PropTypes.object,
  speakers: PropTypes.arrayOf(Speaker),
  speakerIds: PropTypes.object,
  isPlacementTimeDisplayed: PropTypes.bool.isRequired,
  placementDateTime: PropTypes.string.isRequired,
  displayOrder: PropTypes.number.isRequired,
  displayFormat: PropTypes.number.isRequired,
  sessions: PropTypes.arrayOf(Session),
  allowedSessionDisplayFields: PropTypes.arrayOf(PropTypes.number),
  isSessionSelectionRequired: PropTypes.bool.isRequired
});

export const CompositeSession = PropTypes.oneOfType([Session, SessionGroup]);

export const SessionsById = PropTypes.object;

export const SessionContainer = PropTypes.shape({
  includedSessions: SessionsById,
  optionalSessions: SessionsById
});

export const SessionFilters = PropTypes.shape({
  keywordFilterValue: PropTypes.string.isRequired,
  selectedFilterChoices: PropTypes.object.isRequired
});

export const RegistrationType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  availableSessions: PropTypes.arrayOf(PropTypes.string).isRequired,
  isOpenForRegistration: PropTypes.bool.isRequired
});

export const RegistrationTypesById = PropTypes.object;

export const RegistrationPath = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
});

export const RegistrationPathsById = PropTypes.object;

export const EventHotel = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  distanceFromVenue: PropTypes.number.isRequired,
  distanceUnit: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  fax: PropTypes.string.isRequired,
  websiteUrl: PropTypes.string.isRequired
});

export const RegistrationProcess = PropTypes.shape({
  multipleRegistrationPaths: PropTypes.bool.isRequired,
  eventWaitlist: PropTypes.bool.isRequired
});

export const Event = PropTypes.shape({
  id: PropTypes.string.isRequired,
  capacityId: PropTypes.string.isRequired,
  timezone: PropTypes.string.isRequired,
  status: PropTypes.number.isRequired,
  closedReason: PropTypes.number.isRequired,
  products: PropTypes.shape({
    admissionItems: AdmissionItemsById,
    sessionContainer: SessionContainer
  }),
  registrationTypes: RegistrationTypesById,
  eventFeatureSetup: PropTypes.shape({
    agendaItems: PropTypes.shape({
      admissionItems: PropTypes.bool.isRequired
    }),
    fees: PropTypes.shape({
      fees: PropTypes.bool.isRequired,
      merchantAccountId: PropTypes.string.isRequired
    }),
    registrationProcess: RegistrationProcess
  }),
  version: PropTypes.string.isRequired,
  isInTestMode: PropTypes.bool.isRequired
});

export const SessionCategoryListOrder = PropTypes.shape({
  categoryId: PropTypes.string.isRequired,
  categoryOrder: PropTypes.number.isRequired
});

export const SessionCategoryListOrders = PropTypes.object;

export const PrivacyPolicy = PropTypes.shape({
  showPrivacyPolicy: PropTypes.bool.isRequired,
  privacyPolicyUrl: PropTypes.string.isRequired,
  privacyPolicyLinkText: PropTypes.string.isRequired
});

export const CookieBannerSettings = PropTypes.shape({
  showCookieBanner: PropTypes.bool.isRequired,
  showCookieBannerLink: PropTypes.bool.isRequired
});

export const ComplianceSettings = PropTypes.shape({
  privacyPolicy: PrivacyPolicy,
  cookieBannerSettings: CookieBannerSettings
});

export const QuantityItem = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  fees: Fees,
  capacityId: PropTypes.string.isRequired,
  applicableContactTypes: PropTypes.arrayOf(PropTypes.string),
  isOpenForRegistration: PropTypes.bool.isRequired,
  autoCloseDate: PropTypes.string
});


export const DonationItem = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  min: PropTypes.number,
  max: PropTypes.number
});
